module.exports = __webpack_public_path__ + "img/lg-mk.c0e5c8e4.png";